"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(require("./Box"));
var Box_1 = require("./Box");
exports.default = Box_1.default;
//# sourceMappingURL=index.js.map